import {FormView} from '@src/components/_views/configurable/FormView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import ProductForm from './ProductForm';

export class ProductUpdateForm extends FormView {
    protected getFormComponent() {
        return ProductForm;
    }
}

export default ProductUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(ProductUpdateForm));
